module.exports = __webpack_public_path__ + "img/x2000_details.0c414d65.png";